export default {
    filter: {
        phone: 'Phone number from 7, 375, 371',
        email: 'Email address',
        name: 'Full name',
        id: 'Order number',
        pfm: 'PFM Store Code',
    },

    buttonClear: 'Clear',

    block: {
        main: 'Basic information',
        orders: 'Orders',
    },

    fieldsList: {
        phone: 'Phone number',
        email: 'Email address',
        name: 'Full name',
    },

    list: {
        warning: 'To display a list of customers, start typing in any of the fields',
    },

    fieldsMain: {
        phone: 'Phone number',
        email: 'Email address',
        name: 'Full name',
        totalCount: 'Total number of orders',
        issuedCount: 'Number of redeemed',
        buybackPercentage: 'Redemption percentage',
    },

    fieldsOrders: {
        id: 'Order number',
        status: 'Processing status',
        payStatus: 'Payment status',
        payType: 'Payment type',
        deliveryServiceMethod: 'Delivery method',
        deliveryServiceType: 'Type of delivery',
        dateCreate: 'Date of creation',
        pfm: 'PFM Code',
        city: 'Locality',
        address: 'Address',
        deliveryStatus: 'Delivery status',
    },
};